import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import copy from "copy-to-clipboard"

const Button = styled.button.attrs(({ disabled, onClick }) => ({
  onClick: disabled ? undefined : onClick,
}))`
  cursor: pointer;
  border: 1px solid ${tokens.color.border};
  &:hover {
    background-color: ${tokens.color.bgLight};
  }
`

function ClipboardCopy({ value, className }) {
  const [copied, setCopied] = React.useState(false)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false)
    }, 1000)

    return () => clearTimeout(timeout)
  }, [copied])

  return (
    <Button
      aria-label="Copy to clipboard"
      className={className}
      onClick={() => {
        copy(value)
        setCopied(true)
      }}
    >
      {copied ? "Copied!" : "Copy"}
    </Button>
  )
}

ClipboardCopy.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
}

export default ClipboardCopy
